const BASE_ROUTE = 'credit-note-root'

export const ROUTE_NAMES = {
  LIST: 'credit-note-list',
  DETAILS: 'credit-note-details'
}

const ROUTES = {
  [BASE_ROUTE]: {
    name: BASE_ROUTE,
    path: 'credit-note'
  },
  [ROUTE_NAMES.LIST]: {
    name: ROUTE_NAMES.LIST,
    path: 'list'
  },
  [ROUTE_NAMES.DETAILS]: {
    name: ROUTE_NAMES.DETAILS,
    path: ':id'
  }
}

export default [
  {
    name: ROUTES[BASE_ROUTE].name,
    path: ROUTES[BASE_ROUTE].path,
    component: {
      template: '<router-view></router-view>',
      name: 'CreditNoteModule'
    },
    children: [
      {
        name: ROUTES[ROUTE_NAMES.LIST].name,
        path: ROUTES[ROUTE_NAMES.LIST].path,
        component: (resolve) => require(['./views/list'], resolve)
      },
      {
        name: ROUTES[ROUTE_NAMES.DETAILS].name,
        path: ROUTES[ROUTE_NAMES.DETAILS].path,
        component: (resolve) => require(['./views/details'], resolve),
        props: true
      }
    ]
  }
]
